import React from 'react';
import Collect from './Collect';
import Provider from './Provider';
import ErrorBoundary from './ErrorBoundary';

const CollectWithProvider = Provider(Collect);

const CollectWithErrorBoundary = (props) => (
    <ErrorBoundary>
        <CollectWithProvider {...props}/>
    </ErrorBoundary>
);

export default CollectWithErrorBoundary;
